import { render } from "./brandPocFeature.vue?vue&type=template&id=df899512"
import script from "./brandPocFeature.vue?vue&type=script&lang=js"
export * from "./brandPocFeature.vue?vue&type=script&lang=js"

import "./brandPocFeature.vue?vue&type=style&index=0&id=df899512&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__